var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrame98(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 73,
    viewBox: "0 0 72 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0488281,
    width: 72,
    height: 72,
    rx: 36,
    fill: "#71C6A2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.6801 35.7291C38.1864 35.7291 40.59 34.7335 42.3623 32.9613C44.1345 31.189 45.1301 28.7854 45.1301 26.2791C45.1301 23.7728 44.1345 21.3692 42.3623 19.5969C40.59 17.8247 38.1864 16.8291 35.6801 16.8291C33.1738 16.8291 30.7702 17.8247 28.9979 19.5969C27.2257 21.3692 26.2301 23.7728 26.2301 26.2791C26.2301 28.7854 27.2257 31.189 28.9979 32.9613C30.7702 34.7335 33.1738 35.7291 35.6801 35.7291ZM35.6801 40.4541C26.2112 40.4541 18.5 46.8045 18.5 54.6291C18.5 55.1583 18.9158 55.5741 19.445 55.5741H51.9152C52.4444 55.5741 52.8602 55.1583 52.8602 54.6291C52.8602 46.8045 45.149 40.4541 35.6801 40.4541Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame98);
export default __webpack_public_path__ + "static/media/Frame 98.e243c9c337f16d723d49322ff0cda0c0.svg";
export { ForwardRef as ReactComponent };